"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Locale_1 = require("../../Locale");
// const DAY_NAMES = ['日', '一', '二', '三', '四', '五', '六'];
var DAY_NAMES = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
var MONTH_NAMES = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
function Calendar(props) {
  var _a = props.startDay,
    startDay = _a === void 0 ? 0 : _a,
    // ex. 第一天為星期天
    minDate = props.minDate,
    _b = props.disablePast,
    disablePast = _b === void 0 ? false : _b,
    _c = props.weekNumbers,
    weekNumbers = _c === void 0 ? false : _c,
    _d = props.dayNames,
    dayNames = _d === void 0 ? DAY_NAMES.map(function (day) {
      return (0, Locale_1.L)(day).slice(0, 3);
    }) : _d,
    _e = props.onClickPrev,
    onClickPrev = _e === void 0 ? function () {
      return 0;
    } : _e,
    _f = props.onClickNext,
    onClickNext = _f === void 0 ? function () {
      return 0;
    } : _f,
    onSelect = props.onSelect,
    _g = props.defaultValue,
    defaultValue = _g === void 0 ? new Date() : _g,
    renderDate = props.renderDate;
  var date = new Date();
  var _h = (0, react_1.useState)(props.year || date.getFullYear()),
    year = _h[0],
    setYear = _h[1];
  var _j = (0, react_1.useState)(props.month || date.getMonth()),
    month = _j[0],
    setMonth = _j[1];
  var _k = (0, react_1.useState)(new Date(year, month, 1)),
    firstOfMonth = _k[0],
    setFirstMonth = _k[1];
  var _l = (0, react_1.useState)(new Date(year, month + 1, 0).getDate()),
    daysInMonth = _l[0],
    setDaysInMonth = _l[1];
  var _m = (0, react_1.useState)({
      year: date.getFullYear(),
      month: date.getMonth(),
      date: date.getDate(),
      dt: new Date(date.getFullYear(), date.getMonth(), date.getDate())
    }),
    selected = _m[0],
    setSelected = _m[1];
  var _o = (0, react_1.useState)(null),
    selectedElement = _o[0],
    setSelectedElement = _o[1];
  var calc = (0, react_1.useCallback)(function (year, month) {
    if (selectedElement) {
      if (selected.month !== month || selected.year !== year) {
        selectedElement.classList.remove('r-selected');
      } else {
        selectedElement.classList.add('r-selected');
      }
    }
    return {
      firstOfMonth: new Date(year, month, 1),
      daysInMonth: new Date(year, month + 1, 0).getDate()
    };
  }, [selectedElement, selected]);
  (0, react_1.useEffect)(function () {
    var _a = calc(year, month),
      firstOfMonth = _a.firstOfMonth,
      daysInMonth = _a.daysInMonth;
    setFirstMonth(firstOfMonth);
    setDaysInMonth(daysInMonth);
  }, [year, month, calc]);
  var getPrev = (0, react_1.useCallback)(function (_year, _month) {
    onClickPrev(_month > 0 ? {
      year: year,
      month: month - 1
    } : {
      year: year - 1,
      month: 11
    });
    if (_month > 0) {
      setMonth(function (prev) {
        return prev - 1;
      });
    } else {
      setMonth(11);
      setYear(function (prev) {
        return prev - 1;
      });
    }
  }, [onClickPrev, month, year]);
  var getNext = (0, react_1.useCallback)(function (_year, _month) {
    onClickNext(_month < 11 ? {
      year: year,
      month: month + 1
    } : {
      year: year + 1,
      month: 0
    });
    if (_month < 11) {
      setMonth(function (prev) {
        return prev + 1;
      });
    } else {
      setMonth(0);
      setYear(function (prev) {
        return prev + 1;
      });
    }
  }, [onClickNext, month, year]);
  var selectDate = (0, react_1.useCallback)(function (year, month, date, evt) {
    if (selectedElement) {
      selectedElement.classList.remove('r-selected');
    }
    evt.target.classList.add('r-selected');
    var selected = {
      year: year,
      month: month,
      date: date,
      dt: new Date(year, month, date)
    };
    setSelected(selected);
    onSelect(selected);
    setSelectedElement(evt.target);
  }, [selectedElement, onSelect]);
  return react_1.default.createElement(CalendarWrapper, null, react_1.default.createElement("div", {
    className: "r-inner"
  }, react_1.default.createElement(MonthHeader, {
    monthNames: MONTH_NAMES,
    month: month,
    year: year,
    onPrev: getPrev,
    onNext: getNext
  }), react_1.default.createElement(WeekHeader, {
    dayNames: dayNames,
    startDay: startDay,
    weekNumbers: weekNumbers
  }), react_1.default.createElement(MonthDates
  // key={firstOfMonth}
  , {
    // key={firstOfMonth}
    month: month,
    year: year,
    daysInMonth: daysInMonth,
    firstOfMonth: firstOfMonth,
    startDay: startDay,
    onSelect: selectDate,
    weekNumbers: weekNumbers,
    disablePast: disablePast,
    minDate: minDate,
    defaultValue: defaultValue,
    selectedEle: selectedElement,
    renderDate: renderDate
  })));
}
exports.default = Calendar;
function MonthHeader(props) {
  return react_1.default.createElement("div", {
    className: "r-row r-head"
  }, react_1.default.createElement("div", {
    className: "r-cell r-prev",
    onClick: function () {
      return props.onPrev(props.year, props.month);
    },
    role: "button",
    tabIndex: 0
  }), react_1.default.createElement("div", {
    className: "r-cell r-title"
  }, props.year, "-", props.monthNames[props.month]), react_1.default.createElement("div", {
    className: "r-cell r-next",
    onClick: function () {
      return props.onNext(props.year, props.month);
    },
    role: "button",
    tabIndex: 0
  }));
}
function WeekHeader(props) {
  var haystack = Array.from({
    length: 7
  }).map(Number.call, Number);
  return react_1.default.createElement("div", {
    className: "r-row r-weekdays"
  }, function () {
    if (props.weekNumbers) {
      return react_1.default.createElement("div", {
        className: "r-cell r-weeknum"
      }, "wn");
    }
  }(), haystack.map(function (item, i) {
    return react_1.default.createElement("div", {
      key: '' + item + i,
      className: "r-cell"
    }, props.dayNames[(props.startDay + i) % 7]);
  }));
}
function MonthDates(props) {
  var month = props.month,
    year = props.year,
    daysInMonth = props.daysInMonth,
    firstOfMonth = props.firstOfMonth,
    startDay = props.startDay,
    onSelect = props.onSelect,
    weekNumbers = props.weekNumbers,
    disablePast = props.disablePast,
    minDate = props.minDate,
    defaultValue = props.defaultValue,
    selectedEle = props.selectedEle,
    renderDate = props.renderDate;
  var today = (0, react_1.useRef)(new Date()).current;
  var _a = (0, react_1.useMemo)(function () {
      var rows = 5;
      var first = firstOfMonth.getDay(); // 這個月第一天是星期幾
      if ((first === 5 || first === 6) && daysInMonth === 31 || (first === 6 || first === 0) && daysInMonth > 29) {
        rows = 6;
      }
      var day = startDay + 1 - first; // 作爲月曆第一天的定位點，ex. -3 = 上個月倒數第三天
      while (day > 1) {
        day -= 7;
      }
      day -= 1;
      return {
        janOne: new Date(year, 0, 1),
        rows: rows,
        haystack: Array.from(Array(rows).keys()),
        weekStack: Array.from(Array(7).keys()),
        day: day
      };
    }, [firstOfMonth, year, daysInMonth, startDay]),
    janOne = _a.janOne,
    rows = _a.rows,
    haystack = _a.haystack,
    weekStack = _a.weekStack,
    day = _a.day;
  return react_1.default.createElement("div", {
    className: rows === 6 ? 'r-dates' : 'r-dates r-fix'
  }, haystack.map(function (item, i) {
    var firstDateInWeek = day + i * 7; //ex. 第一週第一天 = -3(上個月28號), 第二週第一天 = 4(這個月 5號)
    return react_1.default.createElement("div", {
      key: i,
      className: "r-row"
    }, function () {
      if (weekNumbers) {
        var wn = Math.ceil(((new Date(year, month, firstDateInWeek).valueOf() - janOne.valueOf()) / 86400000 + janOne.getDay() + 1) / 7);
        return react_1.default.createElement("div", {
          className: "r-cell r-weeknum"
        }, wn);
      }
    }(), weekStack.map(function (item, i) {
      var classNames = [];
      var d = firstDateInWeek + i + 1; // 每月幾號
      var isDate = d > 0 && d <= daysInMonth; // 有無在當月
      if (isDate) {
        var current = new Date(year, month, d);
        classNames.push('r-cell');
        classNames.push('r-date');
        if (current.toDateString() === today.toDateString()) {
          classNames.push('r-today');
        }
        if (disablePast && current < today) {
          classNames.push('disabled');
          classNames.push('r-past');
        } else if (minDate && current < minDate) {
          classNames.push('disabled');
          classNames.push('r-past');
        }
        //set defaultValue css
        if (year === defaultValue.getFullYear() && month === defaultValue.getMonth() && d === defaultValue.getDate() && !selectedEle) {
          classNames.push('r-selected');
        }
        return renderDate ? renderDate({
          year: year,
          month: month,
          date: d,
          classNames: classNames,
          onClick: function (e) {
            return onSelect(year, month, d, e);
          }
        }) : react_1.default.createElement("div", {
          key: d,
          className: classNames.join(' '),
          onClick: function (e) {
            if (!classNames.includes('disabled')) {
              onSelect(year, month, d, e);
            }
          }
        }, d);
      }
      return react_1.default.createElement("div", {
        key: d,
        className: "r-cell"
      });
    }));
  }));
}
var CalendarWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: #eee;\n  /* -moz-box-shadow: 0 0 5px #ccc;\n  -webkit-box-shadow: 0 0 5px #ccc;\n  box-shadow: 0 0 5px #ccc; */\n  font: normal 15px Helvetica Neue, Helvetica, Arial, sans-serif;\n  min-width: 200px;\n  position: relative;\n  width: 100%;\n\n  &:after {\n    content: '';\n    display: block;\n    padding-bottom: 100%;\n  }\n\n  & * {\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    -moz-transition: all 0.3s linear;\n    -webkit-transition: all 0.3s linear;\n    -o-transition: all 0.3s linear;\n    transition: all 0.3s linear;\n  }\n  & .r-row {\n    display: flex;\n    flex-flow: row nowrap;\n    width: 100%;\n    justify-content: center;\n  }\n  & .r-cell {\n    background-color: #ffffff;\n    align-items: center;\n    display: flex;\n    flex-flow: row nowrap;\n    flex-grow: 1;\n    flex-basis: 0;\n    justify-content: center;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n  }\n  & .r-head {\n    flex-grow: 1;\n    flex-basis: 0;\n  }\n  & .r-prev,\n  & .r-next {\n    background-color: #ffffff;\n    border-color: #fff;\n    cursor: pointer;\n    outline: none;\n  }\n  & .r-prev:before,\n  & .r-next:before {\n    position: relative;\n    top: 0;\n    content: '';\n    display: inline-block;\n    width: 0.6em;\n    height: 0.6em;\n    border-top: 0.2em solid #999;\n    transform: rotate(-45deg);\n  }\n  & .r-prev:before {\n    border-left: 0.2em solid #999;\n    transform: rotate(-45deg);\n    margin-left: 0.3em;\n  }\n  & .r-prev:hover:before {\n    border-left-color: #ffffff;\n    border-top-color: #ffffff;\n  }\n  & .r-next:before {\n    border-right: 0.2em solid #999;\n    transform: rotate(45deg);\n    margin-right: 0.3em;\n  }\n  & .r-next:hover:before {\n    border-right-color: #ffffff;\n    border-top-color: #ffffff;\n  }\n  & .r-prev:hover,\n  & .r-next:hover {\n    background-color: #ffb438;\n  }\n  & .r-title {\n    flex-grow: 5;\n    flex-basis: max-content;\n  }\n  & .r-weekdays {\n    flex-grow: 1;\n    flex-basis: 0;\n  }\n  & .r-weekdays .r-cell {\n    font-weight: bold;\n  }\n  & .r-dates {\n    display: flex;\n    flex-flow: column nowrap;\n    flex-grow: 6;\n    flex-basis: 0;\n  }\n  & .r-dates.r-fix {\n    flex-grow: 5;\n  }\n  & .r-dates .r-row {\n    flex-grow: 1;\n  }\n  & .r-dates .r-cell {\n    background-color: #ffffff;\n    border: solid 1px #ffffff;\n  }\n  & .r-cell.r-date {\n    flex-direction: column;\n    cursor: pointer;\n    outline: none;\n  }\n  & .r-cell.r-date.r-today {\n    background-color: #ffffff;\n    border: solid 1px #0066cc;\n  }\n  & .r-cell.r-date:not(.disabled, .past):hover {\n    background-color: #ffe2b2; /*#0066CC;*/\n    border: solid 1px #ffe2b2;\n    color: #ffffff;\n  }\n  & .r-cell.r-date.r-selected {\n    background-color: #ffb438;\n    border: solid 1px #ffb438;\n  }\n  & .r-cell.r-date.disabled,\n  .r-cell.r-date.r-past {\n    color: #999999;\n    cursor: not-allowed;\n  }\n  & .r-weeknum {\n    color: #999999;\n    font-size: 0.8em;\n  }\n\n  & .r-inner {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-flow: column nowrap;\n  }\n"], ["\n  background-color: #eee;\n  /* -moz-box-shadow: 0 0 5px #ccc;\n  -webkit-box-shadow: 0 0 5px #ccc;\n  box-shadow: 0 0 5px #ccc; */\n  font: normal 15px Helvetica Neue, Helvetica, Arial, sans-serif;\n  min-width: 200px;\n  position: relative;\n  width: 100%;\n\n  &:after {\n    content: '';\n    display: block;\n    padding-bottom: 100%;\n  }\n\n  & * {\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    -moz-transition: all 0.3s linear;\n    -webkit-transition: all 0.3s linear;\n    -o-transition: all 0.3s linear;\n    transition: all 0.3s linear;\n  }\n  & .r-row {\n    display: flex;\n    flex-flow: row nowrap;\n    width: 100%;\n    justify-content: center;\n  }\n  & .r-cell {\n    background-color: #ffffff;\n    align-items: center;\n    display: flex;\n    flex-flow: row nowrap;\n    flex-grow: 1;\n    flex-basis: 0;\n    justify-content: center;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n  }\n  & .r-head {\n    flex-grow: 1;\n    flex-basis: 0;\n  }\n  & .r-prev,\n  & .r-next {\n    background-color: #ffffff;\n    border-color: #fff;\n    cursor: pointer;\n    outline: none;\n  }\n  & .r-prev:before,\n  & .r-next:before {\n    position: relative;\n    top: 0;\n    content: '';\n    display: inline-block;\n    width: 0.6em;\n    height: 0.6em;\n    border-top: 0.2em solid #999;\n    transform: rotate(-45deg);\n  }\n  & .r-prev:before {\n    border-left: 0.2em solid #999;\n    transform: rotate(-45deg);\n    margin-left: 0.3em;\n  }\n  & .r-prev:hover:before {\n    border-left-color: #ffffff;\n    border-top-color: #ffffff;\n  }\n  & .r-next:before {\n    border-right: 0.2em solid #999;\n    transform: rotate(45deg);\n    margin-right: 0.3em;\n  }\n  & .r-next:hover:before {\n    border-right-color: #ffffff;\n    border-top-color: #ffffff;\n  }\n  & .r-prev:hover,\n  & .r-next:hover {\n    background-color: #ffb438;\n  }\n  & .r-title {\n    flex-grow: 5;\n    flex-basis: max-content;\n  }\n  & .r-weekdays {\n    flex-grow: 1;\n    flex-basis: 0;\n  }\n  & .r-weekdays .r-cell {\n    font-weight: bold;\n  }\n  & .r-dates {\n    display: flex;\n    flex-flow: column nowrap;\n    flex-grow: 6;\n    flex-basis: 0;\n  }\n  & .r-dates.r-fix {\n    flex-grow: 5;\n  }\n  & .r-dates .r-row {\n    flex-grow: 1;\n  }\n  & .r-dates .r-cell {\n    background-color: #ffffff;\n    border: solid 1px #ffffff;\n  }\n  & .r-cell.r-date {\n    flex-direction: column;\n    cursor: pointer;\n    outline: none;\n  }\n  & .r-cell.r-date.r-today {\n    background-color: #ffffff;\n    border: solid 1px #0066cc;\n  }\n  & .r-cell.r-date:not(.disabled, .past):hover {\n    background-color: #ffe2b2; /*#0066CC;*/\n    border: solid 1px #ffe2b2;\n    color: #ffffff;\n  }\n  & .r-cell.r-date.r-selected {\n    background-color: #ffb438;\n    border: solid 1px #ffb438;\n  }\n  & .r-cell.r-date.disabled,\n  .r-cell.r-date.r-past {\n    color: #999999;\n    cursor: not-allowed;\n  }\n  & .r-weeknum {\n    color: #999999;\n    font-size: 0.8em;\n  }\n\n  & .r-inner {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-flow: column nowrap;\n  }\n"])));
var templateObject_1;